import { combineReducers } from 'redux';
import autoRefresh from "./auto-refresh";
import onboarding from "./onboarding";
import transactions from "./transactions";
import investmentHoldings from "./investment-holdings";
import searchResults from "./search-results";
import providers from "./providers";
import topTakeaways from "./top-takeaways";
export default combineReducers({
  autoRefresh: autoRefresh,
  onboarding: onboarding,
  transactions: transactions,
  investmentHoldings: investmentHoldings,
  providers: providers,
  searchResults: searchResults,
  topTakeaways: topTakeaways
});